import { OreSnackBar } from '@edenredespana/oreneta'

import { useNotification } from '@/Shared/ui/notifications/context'

const Notification = (): JSX.Element => {
  const { notification, removeNotification } = useNotification()

  if (!notification.message) return <></>

  return (
    <OreSnackBar
      autoHideDuration={6000}
      color={notification.severity}
      message={notification.message}
      open={true}
      onClose={removeNotification}
      position="top"
    />
  )
}

export { Notification }
